angular.module('webtrader').component('expressOptions', {
  bindings: {
    collapsed: '=',
  },
  templateUrl: BASE_URL+'templates/component.expressOptions.html',
  controller: function (Trades, Quotes, Account) {
    this.quotes = Quotes
    this.account = Account

    this.inc = (val, add) => (typeof val !== 'number' || isNaN(val))? Math.abs(add) : Math.max((val + add).toFixed(2), Math.abs(add))
    this.volume = 3
    this.expiration = 5

    this.orders = [{cmd: 1}, {cmd: 1}, {cmd: 1}]

    this.update = () => {
      let selectedSymbols = []
      let leftQuotes = Quotes.objects.filter((quote) => quote.tradable && (quote.isPair || quote.isMetal))

      for(let order of this.orders) {
        order.choices = leftQuotes

        if (!order.quote)
          order.quote = leftQuotes[0]

        if (order.quote.isMetal) {
          // metal acts like USD
          leftQuotes = leftQuotes.filter((quote) => {
            return quote != order.quote && !quote.symbol.includes('USD') && !quote.isMetal
          })
        } else {
          let l = order.quote.short_symbol.substr(0, 3)
          let r = order.quote.short_symbol.substr(3)
          let metalExclusion = (quote) => order.quote.symbol.includes('USD') ? !quote.isMetal : true
          leftQuotes = leftQuotes.filter((quote) => {
            return !quote.symbol.includes(l) && !quote.symbol.includes(r) && metalExclusion(quote)
          })
        }

        // load global trading stats if symbol was changed
        if (!order.stats || order.stats.symbol != order.quote.symbol) {
          order.stats = null
          order.quote.getTradingStats().then((res) => {
            order.stats = res.data
            order.stats.symbol = order.quote.symbol
          })
        }

      }
    }

    this.updateTotals = () => {
      this.totalProfitPercent = 1

      for(let order of this.orders) {
        if (this.totalProfitPercent)
          this.totalProfitPercent *= order.quote.forecastProfitPercent(this.expiration) / 100 + 1
      }

      // As it is calculated like this: (1.50 * 1.30 * 1.05) - 1
      this.totalProfitPercent = (this.totalProfitPercent - 1) * 100
      this.totalProfit = this.totalProfitPercent / 100 * this.volume
    }

    this.update()
    this.updateTotals()

    this.openTrade = () => {
      Trades.order({
        order_type: 'express',
        volume: +this.volume,
        expiration: this.expiration,
        cmd1: this.orders[0].cmd,
        cmd2: this.orders[1].cmd,
        cmd3: this.orders[2].cmd,
        symbol1: this.orders[0].quote.symbol,
        symbol2: this.orders[1].quote.symbol,
        symbol3: this.orders[2].quote.symbol,
      })
    }
  }
})